import script from "./VoiceCard.vue?vue&type=script&setup=true&lang=js"
export * from "./VoiceCard.vue?vue&type=script&setup=true&lang=js"

import "./VoiceCard.vue?vue&type=style&index=0&id=9c67a7fc&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9c67a7fc"]])

export default __exports__